<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="提现单号" name="apply_number"></c-form-item>
					<c-form-item type="datetime" label="申请时间" start-name="begin_time" end-name="end_time"></c-form-item>
					<c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="手机号码" name="phone"></c-form-item>
					<c-form-item type="input" label="提现账号" name="bank_card"></c-form-item>
					<c-form-item type="select" label="到账渠道" name="withdraw_channel" :options="WithdrawChannel" ></c-form-item>
					<c-form-item type="checkbox" label="状态" name="state" :options="State" ></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="提现账户"
					name="apply_number"
          width="80"
        >
          <template v-slot="{data}">
            <span style="color:coral" v-if="data.account_type==1">资金账户</span>
            <span style="color:blue" v-if="data.account_type==2">收益账户</span>
          </template>
        </c-table-column>

				<c-table-column
					label="提现单号"
					name="apply_number"
                  width="130"
                ></c-table-column>

				<c-table-column
					label="状态"
					name="state"
                  width="80"
                >
					<template v-slot="{data}">
                        <span style="color:coral" v-if="data.state==1">{{stateName[data.state]}}</span>
                        <span style="color:dodgerblue" v-if="data.state==2">{{stateName[data.state]}}</span>
                        <span style="color:dodgerblue" v-if="data.state==3">{{stateName[data.state]}}</span>
                        <span style="color:green" v-if="data.state==4">{{stateName[data.state]}}</span>
                        <span style="color:red" v-if="data.state==5">{{stateName[data.state]}}</span>
                        <span style="color:gray" v-if="data.state==10">{{stateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="会员"
					name="nick_name"
                  width="200"
                >
                  <template v-slot="{data}">
                    <span>
                      {{data.phone}}
                      <span v-if="data.nick_name && data.nick_name!=''">({{data.nick_name}})</span>
                    </span>
                  </template>
                </c-table-column>

				<c-table-column
					label="提现金额"
					name="extract_money"
                  width="90"
                >
                  <template v-slot="{data}">
                    <span style="color:dodgerblue" v-if="data.extract_money && data.extract_money>0">￥{{data.extract_money.toFixed(2)}}</span>
                    <span v-else>--</span>
                  </template>
                </c-table-column>
				
				<c-table-column
					label="提现手续费"
					name="withdraw_fee"
                  width="90"
                >
                  <template v-slot="{data}">
                    <span style="color:dodgerblue" v-if="data.withdraw_fee && data.withdraw_fee>0">￥{{data.withdraw_fee.toFixed(2)}}</span>
                    <span v-else>--</span>
                  </template>
                </c-table-column>

                <c-table-column
                    label="申请时间"
                    name="apply_date"
                    width="140"
                ></c-table-column>

                 <c-table-column
                            label="提现账号"
                            name="withdraw_account_number"
                            width="250"
                 >
					<template v-slot="{data}">
						{{withdrawAccountNumber(data)}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="备注"
					name="remark"
                  width="200"
                ></c-table-column>

				<c-table-column
					label="审批时间"
					name="audit_date"
                  width="140"
                ></c-table-column>
				
				<c-table-column
					label="审批人姓名"
					name="audit_user_realname"
				></c-table-column>
				
				<c-table-column
					label="打款时间"
					name="playmoney_date"
                  width="140"
                ></c-table-column>
				
				<c-table-column
					label="打款人姓名"
					name="playmoney_user_realname"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="190"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/member_account_extract_detail/${data.id}`)">查看</c-table-button>
						<c-table-button v-if="data.state == 1" power="b_member_account_extract_approval" @click="approval(data,2)">审批通过</c-table-button>
						<c-table-button v-if="data.state == 1" power="b_member_account_extract_approval" hollow @click="approval(data,10)">驳回</c-table-button>
						<c-table-button v-if="data.state == 2" power="b_member_account_extract_pay" @click="openPay(data)">打款</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="approvalReason" title="驳回原因" width="400" @resolve="orderApprovalHandle">
			<div class="approval-eason">
				<textarea v-model="approvalReason" placeholder="请输入驳回原因..."></textarea>
			</div>
		</c-dialog>
		
		<c-dialog ref="playmoneyVoucher" title="打款凭证" width="400" @resolve="orderPayHandle">
			<c-form ref="uForm">
				<c-form-item type="image" label="打款凭证" name="playmoney_voucher_url" file-word="" required ></c-form-item>
			</c-form>
		</c-dialog>
		
	</page>
</template>

<script>
	export default {
		name: 'm_member_account_extract',
		data() {
			return {
				stateName: {
					1: '待审批',
					2: '待打款',
					3: '待到账',
					4: '打款到帐',
					5: '打款失败',
					10: '审批驳回'
				},
				State: [{
						name: '待审批',
						value: 1
					},{
						name: '待打款',
						value: 2
					// },{
					// 	name: '待到账',
					// 	value: 3
					},{
						name: '打款到帐',
						value: 4
					// },{
					// 	name: '打款失败',
					// 	value: 5
					},{
						name: '审批驳回',
						value: 10
					}
				],
				WithdrawChannel: [{
						name: '全部',
						value: 0
					},{
						name: '银行卡',
						value: 1
					},{
						name: '支付宝',
						value: 2
					},{
						name: '微信',
						value: 3
					},
				],
				approvalReason: '',
			}
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('member_account_extract.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});

		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/user/extract/list',
					data
				});
			},
			withdrawAccountNumber(data) {
				if(data.withdraw_channel == 1){
					return data.account_name + '（银行卡：' + data.bank_name + ',' +  data.account_name + ',' + data.bank_card+'）';
				}else if(data.withdraw_channel == 2){
					return data.account_name+'（支付宝）';
				}else if(data.withdraw_channel == 3){
					return data.account_name+'（微信）' ;
				}else{
					return '--'
				}
			},
			orderApprovalHandle(stop){
				
				if (!this.approvalReason.trim()) {
					this.$message({
						text: '请填写驳回原因'
					});
					stop();
					return;
				}
				this.request({
					url: '/user/extract/approval',
					data: {id:this.id,state:10,reject_reason:this.approvalReason.trim()},
					loading: true,
					success: data => {
						this.$message({
							text: '驳回成功',
							icon: 'success'
						});
						this.$refs.table.update();
					}
				});
			},
			approval(val,state) {
				//驳回弹框
				if(state == 10){
					this.id = val.id;
					this.$refs.approvalReason.open();
				//通过
				}else if(state == 2){
					this.$confirm({
						text: '确定要审批通过【'+val.apply_number+'】吗？',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/user/extract/approval',
								data: {id:val.id,state:state},
								loading: true,
								success: data => {
									this.$message({
										text: '审批通过成功',
										icon: 'success'
									});
									this.$refs.table.update();
								}
							});
						},  // 确定按钮回调
						cancel: () => {},  // 取消按钮回调
					});
				}
			},
			orderPayHandle(stop){
				stop();
				this.$refs.uForm.submit({
					url: '/user/extract/pay',
					rule: {
						playmoney_voucher_url: [{
							type: 'empty',
							word: '请上传打款凭证图片'
						}]
					},
					dataFormatter: data => {
						data.id = this.id;
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '操作成功',
							icon: 'success'
						});
						this.$refs.playmoneyVoucher.close();
						this.$refs.table.update();
					},
				});
			},
			openPay(val) {
				this.id = val.id;
				this.$refs.playmoneyVoucher.open();
			}
		}
	}
</script>
	
<style lang="stylus" scoped>
	.approval-eason {
		padding: 20px;
		
		textarea {
			box-sizing: border-box;
			width: 100%;
			height: 120px;
			border: none;
			padding: 10px 14px;
			line-height: 20px;
			background: #FAFAFA;
			resize: none;
		}
	}
</style>